import { render } from "./footer-bar.vue?vue&type=template&id=59b70663&scoped=true"
const script = {}

import "./footer-bar.vue?vue&type=style&index=0&id=59b70663&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59b70663"]])

export default __exports__